export default __webpack_public_path__ + "static/media/ic_wftm_40.a143b5ea.svg";